import { render, staticRenderFns } from "./card-by-class.vue?vue&type=template&id=3b08d38e&scoped=true&"
import script from "./card-by-class.vue?vue&type=script&lang=js&"
export * from "./card-by-class.vue?vue&type=script&lang=js&"
import style0 from "./card-by-class.vue?vue&type=style&index=0&id=3b08d38e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b08d38e",
  null
  
)

export default component.exports